module.exports = __webpack_public_path__ + "img/tutorial6.73d513b7.png";